import { PMPackage } from '../types/pm';
import { createProjectItemStore } from './createProjectItemStore';

export const usePackageStore = createProjectItemStore<PMPackage>('packages');
